export class mdlCheckEligibilityReq{

    public PolicyNo:string;
    public RepairType:number;
    public DeductableType:string;
    public SumInsured:number;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlCheckEligibilityReq.ts